import { combineReducers } from 'redux';

import roster from './roster/reducer';

export default combineReducers({
  roster,
});



// WEBPACK FOOTER //
// ./src/pages/rostercurrentbalance/state/reducer.js